import { Type } from '@sinclair/typebox';
import { inspectionTemplateTableSchema } from './inspectionFormTableSchema';

export const inspectionTemplatePaths = {
    '/api/settings/inspection-templates': {
        parameters: [],
        get: {
            operationId: 'inspectionForm.templateList',
            responses: {
                '200': {
                    description: 'List of inspection templates',
                    content: {
                        'application/json': {
                            schema: Type.Array(inspectionTemplateTableSchema),
                        },
                    },
                },
            },
        },
    },
} as const;
